export default {
  name: 'RosterStaffForm',
  props: ['project', 'errors', 'form'],
  watch: {
    'form.staff_photos': function (value) {
      if (value) {
        this.form.staff_q1 = false;
        this.form.staff_q2 = false;
        this.form.staff_q3 = false;
        this.form.staff_q4 = false;
      }
    }
  },
  computed: {
    disableFields() {
      return this.form.staff_photos;
    }
  }
};